import { defineComponent as _defineComponent } from 'vue'
import {computed, onMounted, ref, watch} from 'vue';
import {VuetifyThemeVariant} from 'vuetify/types/services/theme';
import {useInstance} from '@/composables/useInstance';


export default /*#__PURE__*/_defineComponent({
  __name: 'LChip',
  props: {
    small: { type: Boolean },
    close: { type: Boolean },
    color: null,
    noOpacity: { type: Boolean },
    textColor: null,
    disabled: { type: Boolean },
    outlined: { type: Boolean },
    promise: null
  },
  setup(__props: any) {

const props = __props as {
  small?: boolean;
  close: boolean;
  // To generuje vue-warn `Invalid prop type: "null" is not a constructor` ale wszystko działa poprawnie
  // color: keyof VuetifyThemeVariant | 'initial' temporary unitl typescript bump up 5.1.6 fixed this issue
  color: keyof VuetifyThemeVariant;
  noOpacity?: boolean;
  textColor?: keyof VuetifyThemeVariant;
  disabled?: boolean;
  outlined?: boolean;
  promise?: Promise<string>;
}



const {$vuetify,} = useInstance();

const localColor = computed<string>(() =>
  props.color === 'initial'
    ? 'initial'
    : $vuetify.theme.currentTheme[props.color] + (props.noOpacity ? '' : '33'));

const text = ref<Nullable<string>>(null);

onMounted(async() => {
  await setText();
});

if (props.promise) {
  watch(() => props.promise, async() => {
    setText();
  });
}

async function setText() {
  if (props.promise) {
    text.value = await props.promise;
  }
}

return { __sfc: true,props, $vuetify, localColor, text, setText }
}

})